<div
  #panelElement
  ngpMove
  (ngpMove)="onMove($event)"
  [ngStyle]="customStyles"
  [attr.aria-labelledby]="titleId"
  role="dialog"
  aria-modal="false"
  tabindex="0"
  class="help-panel"
>
  <div class="help-panel-header">
    <h6 [id]="titleId" class="help-panel-title">{{ displayTitle }}</h6>
    <!-- TODO: currently a lot of components are placed in the shared folder and this is not a good practice -->
    <button
      type="button"
      class="help-panel-close"
      (click)="close()"
      aria-label="Close help panel"
    >
      ×
    </button>
  </div>

  <div class="help-panel-content">
    @if (contentState$ | async; as state) {
      @if (state.status === "loading") {
        <div class="loading"></div>
      }

      @if (state.status === "error") {
        <div class="error">
          <fa-icon [icon]="faExclamationTriangle"></fa-icon>
          <div class="message">
            {{ state.error }}
          </div>
        </div>
      }
      @if (state.status === "success") {
        <div class="content" [innerHTML]="state.content"></div>
      }
    }
  </div>
</div>
